export enum TopicDetailSendingStatus {
  Sending = 0,
  Sent = 1,
  Failed = 2
}

export enum ActionReceiveMessage {
  Added = 1,
  Modified = 2,
  Deleted = 3
}
